import React from "react";
import "@/App.css";
import "@/touch.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { HudOverlay } from "@/components/hud/HudChrome";
import Nav from "@/components/Nav";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Pricing from "@/pages/Pricing";
import Dashboard from "@/pages/Dashboard";
import Simulation from "@/pages/Simulation";
import BillingReturn from "@/pages/BillingReturn";
import Storefront from "@/pages/shop/Storefront";
import ProductDetail from "@/pages/shop/ProductDetail";
import Cart from "@/pages/shop/Cart";
import Checkout from "@/pages/shop/Checkout";
import OrderReturn from "@/pages/shop/OrderReturn";
import AmazonPending from "@/pages/shop/AmazonPending";
import Studio from "@/pages/shop/Studio";
import Library from "@/pages/Library";
import WorldView from "@/pages/WorldView";
import DesignShare from "@/pages/DesignShare";
import Gallery from "@/pages/Gallery";

function Shell() {
  const location = useLocation();

  // Handle OAuth redirect first (race-condition safe)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const hideNav = location.pathname === "/auth" || location.pathname.startsWith("/simulation/world/");

  return (
    <>
      <HudOverlay />
      {!hideNav && <Nav />}
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/billing/return" element={<ProtectedRoute><BillingReturn /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/simulation" element={<ProtectedRoute><Simulation /></ProtectedRoute>} />
        <Route path="/shop" element={<Storefront />} />
        <Route path="/shop/product/:id" element={<ProductDetail />} />
        <Route path="/d/:id" element={<DesignShare />} />
        <Route path="/explore" element={<Gallery />} />
        <Route path="/shop/cart" element={<Cart />} />
        <Route path="/shop/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
        <Route path="/shop/order/return" element={<ProtectedRoute><OrderReturn /></ProtectedRoute>} />
        <Route path="/shop/order/amazon-pending" element={<ProtectedRoute><AmazonPending /></ProtectedRoute>} />
        <Route path="/studio" element={<ProtectedRoute><Studio /></ProtectedRoute>} />
        <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
        <Route path="/simulation/world/:envId" element={<ProtectedRoute><WorldView /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <CartProvider>
              <Shell />
              <Toaster
                position="top-center"
                theme="dark"
                toastOptions={{
                  style: {
                    background: "rgba(4,12,24,0.92)",
                    border: "1px solid rgba(0,229,255,0.3)",
                    color: "#F8FAFC",
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "12px",
                  },
                }}
              />
            </CartProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
